import script from "./TickTockBombPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TickTockBombPage.vue?vue&type=script&setup=true&lang=js"

import "./TickTockBombPage.vue?vue&type=style&index=0&id=ccaf1c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccaf1c4e"]])

export default __exports__